import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import { Input, Button  } from 'antd';
import {useApi} from "../provider/ApiProvider";




export default function AppConfigPage(){

    const [distance, setDistance] = useState(null);
    const {api, successHandling} = useApi();

    useEffect(() => {
        load();
    },[]);

    async function load(){
        await api.get('/appConfigRouter/config/get').then(resp => {
            console.log(resp, 'resp');
            setDistance(resp.data?.distance);
        })
    }

    function onChangeDistance(e){
        setDistance(e.target.value);
    }

    async function submitDistance(){
        await api.post('/appConfigRouter/config/save', {distance: distance}).then(resp => {

            successHandling("Mesafe ayarınız " + distance + " olarak değiştirildi");
        })
    }
    async function submitUsers(){
        await api.get('/userRouter/user/allUserGet').then(resp => {

            successHandling("Kullanıcılar Güncellendi");
        })
    }

    return (
        <LayoutComponent title={"Ayarlar"} links={
            [
                {
                    title: 'Ayarlar',
                    url: '/'
                },

            ]}
        >
            <>
                <div className={'distance-form'}>
                    <Button onClick={submitUsers} type="primary">Kullanıcıları Güncelle</Button>
                </div><br/>
                <div className={'distance-form'}>
                    <Input value={distance} onChange={onChangeDistance} type={"number"} addonBefore="Minimum Mesafe (m)" defaultValue={distance}/>
                    <Button onClick={submitDistance} type="primary">Kaydet</Button>
                </div>

            </>
        </LayoutComponent>
    )
}



